module.exports = __webpack_public_path__ + "img/sleeve_length.f2149170.png";